tasks-schedules-text
  span {this.firstScheduleText }
  span &nbsp;-&nbsp;
  span {this.lastScheduleText }
  script(type="typescript").
    this.mixin('tasks.schedules-text');
  style(scoped).
    :scope{
      display: inline-block;
    }
